import React from 'react'
import { Header, Cell } from '../../../../../components/Table'
import { getMessage } from '../../../../../lib/translator'

/**
 * Column definition shared by the order's own packlist table and the read-only table the
 * POA section renders for a linked order, so the two can never drift apart.
 */
const PacklistTableHeader = ({ showBarcode = false }) => (
  <Header>
    <Cell className="item-image">
      {getMessage('order.details.itemsTable.header.image')}
    </Cell>
    <Cell className="item-name">
      {getMessage('order.details.itemsTable.header.name')}
    </Cell>
    <Cell>{getMessage('order.details.itemsTable.header.clientItemId')}</Cell>
    {showBarcode && (
      <Cell className="item-barcode">
        {getMessage('order.details.itemsTable.header.barcode')}
      </Cell>
    )}
    <Cell
      className="item-original text-right"
      abbreviation={getMessage(
        'order.details.itemsTable.header.quantity.abbreviated'
      )}
    >
      {getMessage('order.details.itemsTable.header.originalQuantity')}
    </Cell>
    <Cell className="item-final text-right">
      {' '}
      {getMessage('order.details.itemsTable.header.finalQuantity')}
    </Cell>
  </Header>
)

export default PacklistTableHeader
